export function incidentListRoute(): string {
  return '/incident-list';
}

export function incidentArchiveRoute(): string {
  return '/incident-archive';
}

export function incidentDetailRoute(incidentId: string): string {
  return `/incident/${incidentId}`;
}
